import { render, staticRenderFns } from "./SelectProductsFormB2C.vue?vue&type=template&id=86e23c3a&scoped=true"
import script from "./SelectProductsFormB2C.vue?vue&type=script&lang=js"
export * from "./SelectProductsFormB2C.vue?vue&type=script&lang=js"
import style0 from "./SelectProductsFormB2C.vue?vue&type=style&index=0&id=86e23c3a&prod&scoped=true&lang=scss"
import style1 from "./SelectProductsFormB2C.vue?vue&type=style&index=1&id=86e23c3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e23c3a",
  null
  
)

export default component.exports